import React from 'react'
import { ProjectPreviewFragment } from '@sketch/gql-types'
import { pluralize } from '@sketch/components'
import { Container, FolderIcon, DocumentIcon } from './PreviewSubtitle.styles'

export interface PreviewSubtitleProps {
  nestedProjectsCount: ProjectPreviewFragment['nestedProjectsCount']
  sharesCount: ProjectPreviewFragment['sharesCount']
}

export const PreviewSubtitle = (props: PreviewSubtitleProps) => {
  const { nestedProjectsCount, sharesCount } = props

  if (nestedProjectsCount === 0 && sharesCount === 0) {
    return (
      <Container>
        <p>Empty</p>
      </Container>
    )
  }

  const projectsText =
    nestedProjectsCount +
    ' ' +
    pluralize('Folder', 'Folders', nestedProjectsCount)

  const documentsText =
    sharesCount + ' ' + pluralize('Document', 'Documents', sharesCount)

  if (sharesCount === 0) {
    return (
      <Container>
        <FolderIcon />
        <p>{projectsText}</p>
      </Container>
    )
  }

  if (nestedProjectsCount === 0) {
    return (
      <Container>
        <DocumentIcon />
        <p>{documentsText}</p>
      </Container>
    )
  }

  return (
    <Container>
      <Container title={projectsText}>
        <FolderIcon />
        <p>{nestedProjectsCount}</p>
      </Container>
      <Container title={documentsText}>
        <DocumentIcon />
        <p>{sharesCount}</p>
      </Container>
    </Container>
  )
}
